<template>
    <v-row no-gutters class="pt-0" :style="{ paddingLeft: filtersVisible ? '0px' : '10px' }">
        <v-col>
            <v-card>
                <v-card-text>
                    <v-skeleton-loader
                            type="image"
                            :boilerplate="!dataLoading"
                            v-if="showSkeleton"
                            height="350px"
                    />

                    <highcharts v-else ref="chart" :options="chartOptions"></highcharts>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import { Chart } from "highcharts-vue";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";

export default {
    name: 'chart-row',
    components: {
        highcharts: Chart,
    },
    watch: {
        filtersVisible() {
            this.$nextTick(() => {
                if (this.$refs.chart) {
                    this.$refs.chart.chart.reflow();
                }
            });
        },
    },
    data() {
        return {}
    },
    mounted() {
        setTimeout(() => {
            if (this.$refs.chart && this.$refs.chart.chart) {
                this.$refs.chart.chart.reflow();
            }
        }, 100);
    },
    methods: {
        ...mapActions("ProductionAnalysisStore", []),
        ...mapMutations("ProductionAnalysisStore", []),
    },
    computed: {
        ...mapState("ProductionAnalysisStore", ['chartOptions', 'filtersVisible', 'dataLoading', 'showSkeleton']),
    }
};
</script>
<style scoped>
::v-deep .v-skeleton-loader__image {
    height: 100%;
}
::v-deep .highcharts-credits {
    display:none;
}
</style>